(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["commitment-illustration"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
    const section = document.querySelector('.showcase-commitment .plant-graph');
    if (!section) return;

    const svg = section.querySelector('.commitment-illustration');
    const roSvg = section.querySelector('.commitment-illustration-ro');
    const callouts = svg ? Array.from(svg.querySelectorAll('[data-callout]')) : [];

    const animatedLines = svg
      ? Array.from(svg.querySelectorAll('.line-left line, .line-left path, .line-right line, .line-right path'))
      : [];
    const animatedTexts = svg
      ? Array.from(svg.querySelectorAll('.text-left, .text-right, .text-left-dot, .text-right-dot'))
      : [];
    const startDelay = 0.6;
    const lineStagger = 0.03;
    const textLag = 0.4;

    const roAnimatedLines = roSvg
      ? Array.from(roSvg.querySelectorAll('line, path')).filter(
          (el) =>
            !el.closest('defs') &&
            !el.matches('path[fill="#A06127"], path[fill="#A06127"], path[fill="#A06127"], path[fill="#a06127"]')
        )
      : [];
    const roAnnotated = roSvg
      ? [
          ...Array.from(roSvg.querySelectorAll('text')),
          ...Array.from(
            roSvg.querySelectorAll(
              'path[fill="#A06127"], path[fill="#A06127"], path[fill="#A06127"], path[fill="#a06127"]'
            )
          ),
        ]
      : [];

    animatedLines.forEach((line, index) => {
      const length =
        typeof line.getTotalLength === 'function'
          ? line.getTotalLength()
          : Math.hypot(
              (Number(line.getAttribute('x2')) || 0) - (Number(line.getAttribute('x1')) || 0),
              (Number(line.getAttribute('y2')) || 0) - (Number(line.getAttribute('y1')) || 0)
            );

      const isLeft = line.closest('.line-left');
      const startOffset = isLeft ? -length : length;

      line.style.strokeDasharray = length;
      line.style.strokeDashoffset = startOffset;
      line.style.transition = 'none';
      line.dataset.lineDelay = `${startDelay + lineStagger * index}s`;
    });

    const roViewBox = roSvg?.viewBox?.baseVal;
    const roWidth = roViewBox?.width || roSvg?.clientWidth || 0;

    roAnimatedLines.forEach((line, index) => {
      const length =
        typeof line.getTotalLength === 'function'
          ? line.getTotalLength()
          : Math.hypot(
              (Number(line.getAttribute('x2')) || 0) - (Number(line.getAttribute('x1')) || 0),
              (Number(line.getAttribute('y2')) || 0) - (Number(line.getAttribute('y1')) || 0)
            );

      let isLeft = false;
      if (roWidth) {
        const bbox = line.getBBox();
        const midX = bbox.x + bbox.width / 2;
        isLeft = midX < roWidth / 2;
      }

      const startOffset = isLeft ? -length : length;

      line.style.strokeDasharray = length;
      line.style.strokeDashoffset = startOffset;
      line.style.transition = 'none';
      line.dataset.lineDelay = `${startDelay + lineStagger * index}s`;
    });

    animatedTexts.forEach((text, index) => {
      const delay = startDelay + textLag + lineStagger * index;
      text.style.setProperty('--text-delay', `${delay}s`);
    });

    const roTextBase = startDelay + textLag;
    const roTextStagger = 0.01;
    roAnnotated.forEach((el, index) => {
      const delay = roTextBase + roTextStagger * index;
      el.style.setProperty('--text-delay', `${delay}s`);
    });

    const toUnit = (percent, max) => (Number(percent) / 100) * max;

    const positionCallouts = () => {
      if (!svg || !callouts.length) return;

      const viewBox = svg.viewBox?.baseVal;
      const width = viewBox?.width || svg.clientWidth;
      const height = viewBox?.height || svg.clientHeight;
      if (!width || !height) return;

      callouts.forEach((group) => {
        const anchor = (group.dataset.anchor || '').split(',').map((value) => Number(value.trim()));
        const target = (group.dataset.target || '').split(',').map((value) => Number(value.trim()));
        if (anchor.length !== 2 || target.length !== 2) return;

        const [anchorXPct, anchorYPct] = anchor;
        const [targetXPct, targetYPct] = target;

        if (
          Number.isNaN(anchorXPct) ||
          Number.isNaN(anchorYPct) ||
          Number.isNaN(targetXPct) ||
          Number.isNaN(targetYPct)
        ) {
          return;
        }

        const anchorX = toUnit(anchorXPct, width);
        const anchorY = toUnit(anchorYPct, height);
        const targetX = toUnit(targetXPct, width);
        const targetY = toUnit(targetYPct, height);

        const line = group.querySelector('.callout__connector');
        if (line) {
          line.setAttribute('x1', anchorX);
          line.setAttribute('y1', anchorY);
          line.setAttribute('x2', targetX);
          line.setAttribute('y2', targetY);
        }

        const origin = group.querySelector('.callout__origin');
        if (origin) {
          origin.setAttribute('cx', anchorX);
          origin.setAttribute('cy', anchorY);
        }

        const terminus = group.querySelector('.callout__terminus');
        if (terminus) {
          terminus.setAttribute('cx', targetX);
          terminus.setAttribute('cy', targetY);
        }

        const labelGap = Number(group.dataset.labelGap || 12);
        const isLeft = group.classList.contains('callout--left');
        const label = group.querySelector('.callout__label');
        if (label) {
          const labelX = isLeft ? targetX - labelGap : targetX + labelGap;
          label.setAttribute('x', labelX);
          label.setAttribute('y', targetY);
        }
      });
    };

    positionCallouts();
    window.addEventListener('resize', positionCallouts);

    const reveal = () => {
      section.classList.add('is-visible');

      requestAnimationFrame(() => {
        [...animatedLines, ...roAnimatedLines].forEach((line) => {
          line.style.transition = `stroke-dashoffset 1s ease-in-out ${line.dataset.lineDelay || '0s'}`;
          line.style.strokeDashoffset = 0;
        });
      });
    };

    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(
        (entries, obs) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            reveal();
            obs.disconnect();
          });
        },
        { rootMargin: '0px 0px -10%', threshold: 0.25 }
      );

      observer.observe(section);
    } else {
      reveal();
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["halves-graphic-mobile"] && !Shopify.designMode) return;
  try {
    (() => {
    const svg = document.querySelector('.halves-graphic-mobile');
    if (!svg) return;

    const orderedIds = ['Path_918', 'Path_917', 'Line_88', 'Ellipse_864', 'Line_89'];
    const prepAnimation = () => {
      let delay = 0;
      const step = 0.25;
      orderedIds.forEach((id) => {
        const el = svg.getElementById(id);
        if (!el) return;
        const length = typeof el.getTotalLength === 'function' ? el.getTotalLength() : 0;
        el.classList.add('animate-stroke');
        el.style.strokeDasharray = length;
        el.style.strokeDashoffset = length;
        const duration = id === 'Ellipse_864' ? 1.4 : 1.1;
        el.dataset.animDuration = duration;
        el.dataset.animDelay = delay;
        delay += step;
      });

      const used = new Set(orderedIds);
      const leftovers = svg.querySelectorAll('#lines line, #lines path, #lines circle');
      let dotIdx = 0;
      leftovers.forEach((el) => {
        if (used.has(el.id)) return;
        const length = typeof el.getTotalLength === 'function' ? el.getTotalLength() : 0;
        const d = 0.1 + dotIdx * 0.05;
        if (length > 0) {
          el.classList.add('animate-stroke');
          el.style.strokeDasharray = length;
          el.style.strokeDashoffset = length;
          el.dataset.animDuration = 1.1;
          el.dataset.animDelay = d;
        } else {
          el.classList.add('animate-fade');
          el.dataset.animDelay = d;
        }
        dotIdx += 1;
      });

      ['nut-left', 'nut-right', 'nut-center'].forEach((id, idx) => {
        const el = svg.getElementById(id);
        if (!el) return;
        el.classList.add('animate-fade');
        el.dataset.animDelay = 0.2 + idx * 0.2;
      });
    };

    const playAnimation = () => {
      svg.querySelectorAll('.animate-stroke').forEach((el) => {
        const duration = el.dataset.animDuration || 1.1;
        const d = el.dataset.animDelay || 0;
        el.style.animation = `mobile-draw-line ${duration}s ease forwards`;
        el.style.animationDelay = `${d}s`;
      });
      svg.querySelectorAll('.animate-fade').forEach((el) => {
        const d = el.dataset.animDelay || 0;
        el.style.animation = `mobile-fade-in 0.6s ease forwards`;
        el.style.animationDelay = `${d}s`;
      });
    };

    prepAnimation();

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            playAnimation();
            observer.disconnect();
          }
        });
      },
      { threshold: 0.3 }
    );
    observer.observe(svg);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["halves-graphic"] && !Shopify.designMode) return;
  try {
    (() => {
    const svg = document.querySelector('.halves-graphic-svg');
    if (!svg) return;

    const orderedIds = ['Path_918', 'Path_917', 'Line_88', 'Ellipse_864', 'Line_89', 'Path_919', 'Path_920', 'Path_922', 'Path_921'];

    let delay = 0;
    const step = 0.25;

    const prepAnimation = () => {
      orderedIds.forEach((id) => {
        const el = svg.getElementById(id);
        if (!el) return;
        const length = typeof el.getTotalLength === 'function' ? el.getTotalLength() : 0;
        el.classList.add('animate-stroke');
        el.style.strokeDasharray = length;
        // Flip Line_88 to draw in the opposite direction
        const startOffset = id === 'Line_88' ? -length : length;
        el.style.strokeDashoffset = startOffset; /* hide initially */
        const duration = id === 'Ellipse_864' ? 1.4 : 1.1;
        el.dataset.animDuration = duration;
        el.dataset.animDelay = delay;
        delay += step;
      });

      const used = new Set(orderedIds);
      const leftovers = svg.querySelectorAll('g#Group_101 line, g#Group_101 path, g#Group_101 circle');
      let dotIdx = 0;
      leftovers.forEach((el) => {
        if (used.has(el.id)) return;
        const length = typeof el.getTotalLength === 'function' ? el.getTotalLength() : 0;
        const d = 0.1 + dotIdx * 0.05;
        if (length > 0) {
          el.classList.add('animate-stroke');
          el.style.strokeDasharray = length;
          el.style.strokeDashoffset = length;
          el.dataset.animDuration = 1.1;
          el.dataset.animDelay = d;
        } else {
          el.classList.add('animate-fade');
          el.dataset.animDelay = d;
        }
        dotIdx += 1;
      });
    };

    const setImageDelays = () => {
      const imgs = ['nut-left', 'nut-right', 'nut-center'];
      imgs.forEach((id, idx) => {
        const el = svg.getElementById(id);
        if (!el) return;
        el.classList.add('animate-fade');
        el.dataset.animDelay = 0.2 + idx * 0.2;
      });
    };

    const playAnimation = () => {
      svg.classList.add('is-visible');
      svg.querySelectorAll('.animate-stroke').forEach((el) => {
        const duration = el.dataset.animDuration || 1.1;
        const d = el.dataset.animDelay || 0;
        el.style.animation = `draw-line ${duration}s ease forwards`;
        el.style.animationDelay = `${d}s`;
      });
      svg.querySelectorAll('.animate-fade').forEach((el) => {
        const d = el.dataset.animDelay || 0;
        el.style.animation = `fade-in 0.6s ease forwards`;
        el.style.animationDelay = `${d}s`;
      });
    };

    prepAnimation();
    setImageDelays();

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            playAnimation();
            observer.disconnect();
          }
        });
      },
      { threshold: 0.3 }
    );
    observer.observe(svg);
  })();
  } catch(e) { console.error(e); }
})();

})();
